export default "__VITE_ASSET__DfMWHGIa__"